import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxCashForward } from '@/store/cash/state.ts';

export const SavedCashForwardValidator = arkScope.type({
  type: '"FxFwd"',
  properties: {
    'currencyPair?': 'string',
    'maturityDateTenor?': 'string',
    'notional?': 'number',
    notionalCurrencyIndex: arkScope.type('CurrencyChoice').default(1),
  },
  tileId: 'string',
  clientId: 'number?',
});
export type SavedCashForward = typeof SavedCashForwardValidator.infer;

export const SavedCashForward = {
  fromFxCashForward: (x: FxCashForward, tileId: string): SavedCashForward => ({
    type: 'FxFwd',
    properties: {
      currencyPair: x.properties.currencyPair,
      maturityDateTenor: x.properties.maturityDateTenor,
      notional: x.properties.notional,
      notionalCurrencyIndex: x.properties.notionalCurrencyIndex ?? 1,
    },
    tileId,
    clientId: x.clientId,
  }),
};
